import { z } from 'zod';
// The brand's declared funnel — an ordered conversion-event spine, top → win.
// Read by buildBrandFunnel as the fallback spine when a campaign doesn't declare
// its own. See packages/db/src/schema/brand-funnel-definitions.ts.
export const brandFunnelDefinitionSchema = z.object({
    brandId: z.string().uuid(),
    /** Ordered conversion-event names, earliest touchpoint first, the win last. */
    steps: z.array(z.string().min(1).max(120)).min(2).max(8),
    label: z.string().max(120).nullable(),
    updatedAt: z.string(),
});
/** Payload to set/replace a brand's funnel definition. */
export const setBrandFunnelDefinitionSchema = z.object({
    steps: z.array(z.string().min(1).max(120)).min(2).max(8),
    label: z.string().max(120).nullish(),
});
//# sourceMappingURL=brand-funnel-definition.js.map